import { APP_CONFIG } from '../configs/config';

export const getAccessToken = () => {
  try {
    const match = document.cookie
      .split('; ')
      .find(row => row.startsWith('access_token='));
    
    if (match) {
      const token = match.split('=')[1];
      if (token) {
        return decodeURIComponent(token);
      }
    }
    
    const stored = localStorage.getItem('access_token');
    return stored || null;
  } catch (error) {
    console.error('[AuthCookieHelpers] Error reading access token:', error);
    return null;
  }
};

export const getUserData = () => {
  try {
    const match = document.cookie
      .split('; ')
      .find(row => row.startsWith('user_data='));
    
    if (match) {
      const encoded = match.split('=')[1];
      if (encoded) {
        const decoded = decodeURIComponent(encoded);
        return JSON.parse(decoded);
      }
    }
    
    const stored = localStorage.getItem('user_data');
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.error('[AuthCookieHelpers] Error reading user data:', error);
    return null;
  }
};

export const isAuthenticated = () => {
  const token = getAccessToken();
  return token !== null && token !== '';
};

export const getAuthData = () => {
  const token = getAccessToken();
  const user = getUserData();
  const authenticated = token !== null && token !== '';
  
  return {
    token,
    user,
    isAuthenticated: authenticated,
    isLoading: false
  };
};

export const getAuthHeaders = () => {
  const token = getAccessToken();
  
  if (!token) {
    return {
      'Content-Type': 'application/json'
    };
  }
  
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
};

export const authenticatedFetch = async (url, options = {}) => {
  const headers = getAuthHeaders();
  
  return fetch(url, {
    ...options,
    headers: {
      ...headers,
      ...options.headers
    },
    credentials: 'include'
  });
};

export const redirectToAuthIfNeeded = (authUrl = APP_CONFIG.MAIN_WEBSITE_ORIGIN) => {
  if (!isAuthenticated()) {
    const returnUrl = encodeURIComponent(window.location.href);
    window.location.href = `${authUrl}/signin?returnUrl=${returnUrl}`;
  }
};

export const extractAuthFromUrl = () => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const userDataParam = urlParams.get('user');
    
    if (token && userDataParam) {
      console.log('[AuthCookieHelpers] 🔑 Extracting auth from URL parameters');
      
      localStorage.setItem('access_token', token);
      localStorage.setItem('user_data', decodeURIComponent(userDataParam));
      
      console.log('[AuthCookieHelpers] ✅ Auth data stored in localStorage');
      
      urlParams.delete('token');
      urlParams.delete('user');
      
      const cleanUrl = window.location.pathname + 
        (urlParams.toString() ? '?' + urlParams.toString() : '') +
        window.location.hash;
      
      window.history.replaceState({}, document.title, cleanUrl);
      console.log('[AuthCookieHelpers] 🧹 URL cleaned');
      
      return true;
    }
    
    return false;
  } catch (error) {
    console.error('[AuthCookieHelpers] Error extracting auth from URL:', error);
    return false;
  }
};

export const clearAuthData = () => {
  try {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user_data');
    
    document.cookie = 'access_token=; Path=/; Max-Age=0';
    document.cookie = 'user_data=; Path=/; Max-Age=0';
    
    console.log('[AuthCookieHelpers] 🧹 Auth data cleared');
  } catch (error) {
    console.error('[AuthCookieHelpers] Error clearing auth data:', error);
  }
};

export const debugAuthCookies = () => {
  console.log('🍪 Authentication Debug');
  console.log('All cookies:', document.cookie);
  console.log('localStorage token:', localStorage.getItem('access_token') ? '✅ Present' : '❌ Not found');
  console.log('localStorage user:', localStorage.getItem('user_data') ? '✅ Present' : '❌ Not found');
  console.log('Access Token (combined):', getAccessToken() ? '✅ Present' : '❌ Not found');
  console.log('User Data (combined):', getUserData());
  console.log('Is Authenticated:', isAuthenticated());
};

const authCookieHelpers = {
  getAccessToken,
  getUserData,
  isAuthenticated,
  getAuthData,
  getAuthHeaders,
  authenticatedFetch,
  redirectToAuthIfNeeded,
  extractAuthFromUrl,
  clearAuthData,
  debugAuthCookies
};

export default authCookieHelpers;

